import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { DialogData } from 'src/app/entities/dialogData';

@Component({
  selector: 'gov-notification-details-dialog',
  templateUrl: './notification-details-dialog.component.html',
  styleUrls: ['./notification-details-dialog.component.css']
})
export class NotificationDetailsDialogComponent implements OnInit {
  currentUser: any;

  constructor(
    public dialogRef: MatDialogRef<NotificationDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private translateService: TranslateService,
  ) {}

  ngOnInit() {}

  getActionText(type) {
    switch (type) {
      case 'PAYMENT_DELETE':
        return this.translateService.instant('NOTIFICATIONS.SUMMARY_PAYMENT_DELETE');
      case 'RECURSION_DELETE':
        return this.translateService.instant('NOTIFICATIONS.SUMMARY_RECURSION_DELETE');
      case 'DECLARATION_DELETE':
        return this.translateService.instant('NOTIFICATIONS.SUMMARY_DECLARATION_DELETE');
      case 'RECURSION_STOPPED':
        return this.translateService.instant('NOTIFICATIONS.SUMMARY_RECURSION_STOPPED');
      case 'RECURSION_RESTARTED':
        return this.translateService.instant('NOTIFICATIONS.SUMMARY_RECURSION_RESTARTED');
      case 'ARCHIVE':
      return this.translateService.instant('NOTIFICATIONS.SUMMARY_ARCHIVE');
      case 'REVIVE':
      return this.translateService.instant('NOTIFICATIONS.SUMMARY_REVIVE');
      default:
        return '';
    }
  }
  

  onClose() {
    this.dialogRef.close();
  }
}
